import { useCallback } from 'react';
import { usePym, useWidget } from '@telescope/cassini-hooks';
import { GenericObject } from '@telescope/cassini-utilities';
import { Open } from 'generated-types/widget';

export const useScroll = () => {
  const { pym } = usePym();

  const { data: offsetSettings } = useWidget<Open>({
    select: (data) => data.widget.settings.iframe.offset,
  });

  const scrollToTop = useCallback(() => {
    if (pym) {
      let offset = 0;

      if (offsetSettings) {
        Object.values(offsetSettings as GenericObject).forEach((item: any) => {
          const breakpoint = parseInt(item.breakpoint, 10);
          if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
            offset = parseInt(item.offset, 10);
          }
        });
      }

      const pos = JSON.stringify({ x: 0, y: -offset });
      pym.sendMessage('scrollToChildPosition', pos);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pym, offsetSettings]);

  return { scrollToTop };
};
